import RadioGroup from '@admin/components/form/radiogroup'
import ModalPanel from '@admin/components/modal_panel'
import PropTypes from 'prop-types'
import React from 'react'

class Checkbox extends React.Component {

  static propTypes = {
    defaultValue: PropTypes.object,
    code: PropTypes.string,
    comparisons: PropTypes.array,
    name: PropTypes.string,
    format: PropTypes.func,
    onCancel: PropTypes.func,
    onChange: PropTypes.func,
    onDone: PropTypes.func
  }

  state = {
    operator: null
  }

  _handleCancel = this._handleCancel.bind(this)
  _handleChange = this._handleChange.bind(this)
  _handleDone = this._handleDone.bind(this)
  _handleOperator = this._handleOperator.bind(this)

  render() {
    return (
      <ModalPanel { ...this._getPanel() }>
        <div className="maha-criterion-form">
          <div className="maha-criterion-form-header">
            <RadioGroup { ...this._getRadioGroup() } />
          </div>
          <div className="maha-criterion-form-body" />
        </div>
      </ModalPanel>
    )
  }

  componentDidMount() {
    const { defaultValue } = this.props
    if(defaultValue) this._handleSet(defaultValue)
  }

  componentDidUpdate(prevProps, prevState) {
    const { operator } = this.state
    if(operator !== prevState.operator) {
      this._handleChange()
    }
  }

  _getOperators() {
    const { comparisons } = this.props
    return comparisons || [
      { value: '$ck', text: 't(is checked)' },
      { value: '$nck', text: 't(is not checked)' }
    ]
  }

  _getPanel() {
    const { value } = this.state
    const { name } = this.props
    return {
      title: name,
      leftItems: [
        { svg: 'chevron_left', handler: this._handleCancel }
      ],
      buttons: [{
        label: 'Add Criteria',
        color: 'blue',
        disabled: value === null,
        handler: this._handleDone
      }]
    }
  }

  _getRadioGroup() {
    const options = this._getOperators()
    const { operator } = this.state
    return {
      defaultValue: operator || options[0].value,
      deselectable: false,
      options,
      onChange: this._handleOperator
    }
  }

  _handleCancel() {
    this.props.onCancel()
  }

  _handleChange() {
    const { code, format } = this.props
    const { operator } = this.state
    const operators = this._getOperators()
    const chosen = operators.find(({ value }) => {
      return value === operator
    })
    this.props.onChange({
      code,
      operator,
      data: format ? format(chosen) : chosen.text,
      value: true
    })
  }

  _handleDone() {
    const { code, format } = this.props
    const { operator } = this.state
    const operators = this._getOperators()
    const chosen = operators.find(({ value }) => {
      return value === operator
    })
    this.props.onDone({
      code,
      operator,
      data: format ? format(chosen) : chosen.text,
      value: true
    })
  }

  _handleOperator(operator) {
    this.setState({ operator })
  }

}

export default Checkbox
